module.exports = __webpack_public_path__ + "img/vendor-icon-photographer.1fc7a792.png";